// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__fP8NN","footerFilter":"Footer_footerFilter__1BgQf","footerCreate":"Footer_footerCreate__1lcWo"};